import React, { useState } from 'react';
import { PASSWORD_RULES } from '../utils/password';
import '../styles/AuthPage.css';

export function PasswordRequirements({ password }) {
    const value = typeof password === 'string' ? password : '';

    return (
        <ul className="pw-rules" aria-label="Password requirements">
            {PASSWORD_RULES.map((rule) => {
                const met = rule.test(value);
                return (
                    <li
                        key={rule.id}
                        className={met ? 'pw-rule pw-rule--met' : 'pw-rule'}
                    >
                        <span className="pw-rule-mark" aria-hidden="true">
                            {met ? '✓' : ''}
                        </span>
                        <span>{rule.label}</span>
                    </li>
                );
            })}
        </ul>
    );
}

export function PasswordMatchHint({ password, confirm }) {
    if (!confirm) return null;
    const matches = password === confirm;
    return (
        <p className={matches ? 'pw-match pw-match--ok' : 'pw-match'} role="status">
            {matches ? 'Passwords match' : 'Passwords do not match'}
        </p>
    );
}

const PasswordField = ({
    id,
    name,
    label,
    value,
    onChange,
    placeholder,
    autoComplete,
    disabled = false,
    showRules = false,
}) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="auth-field">
            <div className="auth-field-head">
                <label htmlFor={id}>{label}</label>
                <button
                    type="button"
                    className="auth-reveal"
                    aria-controls={id}
                    aria-pressed={visible}
                    onClick={() => setVisible((current) => !current)}
                    disabled={disabled}
                >
                    {visible ? 'Hide' : 'Show'}
                </button>
            </div>
            <input
                id={id}
                name={name}
                type={visible ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete={autoComplete}
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                required
                disabled={disabled}
            />
            {showRules && <PasswordRequirements password={value} />}
        </div>
    );
};

export default PasswordField;
